"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferUnderListingDtoListingStatusEnum = exports.OfferUnderListingDtoCampaignEnum = void 0;
exports.instanceOfOfferUnderListingDto = instanceOfOfferUnderListingDto;
exports.OfferUnderListingDtoFromJSON = OfferUnderListingDtoFromJSON;
exports.OfferUnderListingDtoFromJSONTyped = OfferUnderListingDtoFromJSONTyped;
exports.OfferUnderListingDtoToJSON = OfferUnderListingDtoToJSON;
exports.OfferUnderListingDtoToJSONTyped = OfferUnderListingDtoToJSONTyped;
var OfferUnderPropertyDto_1 = require("./OfferUnderPropertyDto");
/**
 * @export
 */
exports.OfferUnderListingDtoCampaignEnum = {
    VendorManaged: 'vendor_managed',
    UnreservedManaged: 'unreserved_managed'
};
/**
 * @export
 */
exports.OfferUnderListingDtoListingStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    UnderOffer: 'under_offer',
    OffTheMarket: 'off_the_market',
    PassedIn: 'passed_in',
    Disabled: 'disabled',
    Deleted: 'deleted',
    Sold: 'sold'
};
/**
 * Check if a given object implements the OfferUnderListingDto interface.
 */
function instanceOfOfferUnderListingDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('listingType' in value) || value['listingType'] === undefined)
        return false;
    if (!('price' in value) || value['price'] === undefined)
        return false;
    if (!('property' in value) || value['property'] === undefined)
        return false;
    return true;
}
function OfferUnderListingDtoFromJSON(json) {
    return OfferUnderListingDtoFromJSONTyped(json, false);
}
function OfferUnderListingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'listingType': json['listingType'],
        'priceText': json['priceText'] == null ? undefined : json['priceText'],
        'campaign': json['campaign'] == null ? undefined : json['campaign'],
        'displayPrice': json['displayPrice'] == null ? undefined : json['displayPrice'],
        'price': json['price'],
        'property': (0, OfferUnderPropertyDto_1.OfferUnderPropertyDtoFromJSON)(json['property']),
        'listingStatus': json['listingStatus'] == null ? undefined : json['listingStatus'],
        'slug': json['slug'] == null ? undefined : json['slug'],
    };
}
function OfferUnderListingDtoToJSON(json) {
    return OfferUnderListingDtoToJSONTyped(json, false);
}
function OfferUnderListingDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'listingType': value['listingType'],
        'priceText': value['priceText'],
        'campaign': value['campaign'],
        'displayPrice': value['displayPrice'],
        'price': value['price'],
        'property': (0, OfferUnderPropertyDto_1.OfferUnderPropertyDtoToJSON)(value['property']),
        'listingStatus': value['listingStatus'],
        'slug': value['slug'],
    };
}
